import RouteParser from 'route-parser'

import RouteTemplate from '../../html/components/route.html'

import Component from '../shared/component'

export const Route = Component('v-route', {
  model: {
    event: 'change'
  },
  template: RouteTemplate,
  props: {
    path: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      route: null,
      active: false,
      params: {}
    }
  },
  computed: {
    location () {
      const {path, search, hash} = this.$url

      switch (this.path[0] || false) {
        case '/':
          return path
        case '?':
          return search
        case '#':
          return hash
        default:
          return path + search + hash
      }
    }
  },
  watch: {
    path: {
      immediate: true,
      handler () {
        this.route = new RouteParser(this.path)
      }
    },

    location: {
      immediate: true,
      handler () {
        const match = this.route.match(this.location)

        this.active = match !== false
        this.params = match === false ? {} : match
      }
    },

    params: {
      immediate: true,
      deep: true,
      handler () {
        const reversed = this.route.reverse(this.params)

        if (reversed && reversed !== this.location) {
          switch (this.path[0] || false) {
            case '/':
              this.$url.path = reversed
              break
            case '?':
              this.$url.search = reversed
              break
            case '#':
              this.$url.hash = reversed
          }
        }

        setTimeout(() => {
          this.$emit('change', {
            active: this.active,
            params: this.params
          })
        })
      }
    }
  }
})
